import qs, { ParsedUrlQueryInput } from 'querystring-es3';
import { useLocation } from 'react-router-dom';
import moment from 'moment';

// Used to parse json to a query string
//!!r-18-dj
//@ts-ignore
export const qsStringify = (body: ParsedUrlQueryInput) => {
    return qs.stringify(body);
}

//Query Parameters Function
export const useQuery = () => new URLSearchParams(useLocation().search);

// Creates an array of objects with value and label keys
export const createOptionsList = (array: Array<any>, valueKey: string = "id", labelKey: string="text"): Array<{value : string, label : string}> => {
    let options: Array<{ value: string, label : string }> = [];
    array.forEach(item => {
        options.push({ value: item[valueKey], label : item[labelKey]});
    })
    return options;
}

export const getDateRange = (startDate: Date | any, stopDate: Date | any, format = 'YYYY-MM-DD'): Array<string> => {
    let dateArray = [];
    let fromDate = moment(startDate);
    let toDate = moment(stopDate);
    // //console.log(startDate, stopDate);
    while (moment(fromDate).format("MM-DD-YYYY") !== moment(toDate).format("MM-DD-YYYY")) {
        // //console.log(moment(fromDate).format("MM-DD-YYYY"), moment(toDate).format("MM-DD-YYYY"));
        
        dateArray.push( moment(fromDate).format(format) )
        fromDate = moment(fromDate).add(1, 'days');
    }
    return dateArray;
}

export const deleteAllCookies = () => {
    //console.log("Clearing Cookies");
    let cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}
